
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import WidgetTools from "./widgetTools";
import { removeWidget } from "src/redux/supervisorSlice";
import WidgetSettings from './widgetSettings';
import { selectionTypes } from '../utils/consts';
import MonitorWSService from '../../services/monitorwsservice';
import {
    Chart,
    Series,
    ArgumentAxis,
    CommonSeriesSettings,
    CommonAxisSettings,
    Grid,
    Export,
    Legend,
    Margin,
    Tooltip,
    Label,
    Format,
    Animation
} from 'devextreme-react/chart';
import { Row, Col } from 'react-bootstrap';
import { seconds2HMS } from '../utils/utils';

function MaxWaitingTimeByHour(props) {
    const { t } = useTranslation();
    const [showSettings, setShowSettings] = useState(false);
    const [calls, setCalls] = useState([]);
    const architectureSources = [
        { value: 'total', name: t("total"), color: "#50cd89" }
    ];
    const [groupId, setGroupId] = useState(-1);
    const [groupName, setGroupName] = useState(localStorage.getItem(`MaxWaitingTimeByHour_groupName_${props.identifier}_user${props.id}`) || t("all2"));
    const [maxTimeWaiting, setMaxTimeWaiting] = useState(0);

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send("/app/unsubscribe/maximumwaitingtimebyhour", {}, JSON.stringify({
                    token: props.token,
                }));

                MonitorWSService.stompClient.unsubscribe("maximumwaitingtimebyhour");
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (props.connected) {
            let groupId = parseInt(localStorage.getItem(`MaxWaitingTimeByHour_groupId_${props.identifier}_user${props.id}`) || -1);
            setGroupId(groupId);
            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/maximumwaitingtimebyhour/`, function (callsbygroup) {
                if (!document.hidden && localStorage.getItem("resizing") !== "true") {

                    let data = JSON.parse(callsbygroup.body);

                    let callsData = [];

                    for (let index = 0; index < data.maxCallsDurationByHour.length; index++) {
                        const total = data.maxCallsDurationByHour[index];

                        callsData.push({
                            hour: total.hour,
                            total: total.data
                        });
                    }

                    setCalls(callsData);

                    setMaxTimeWaiting(data.maxActiveDuration);
                }
            }, { id: "maximumwaitingtimebyhour" });

            MonitorWSService.stompClient.send("/app/subscribe/maximumwaitingtimebyhour", {}, JSON.stringify({
                token: props.token,
                groupId: groupId
            }));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const setGroup = (groupId, groupName) => {
        setShowSettings(!showSettings);
        setGroupId(groupId);
        setGroupName(groupName);
        localStorage.setItem(`MaxWaitingTimeByHour_groupId_${props.identifier}_user${props.id}`, groupId);
        localStorage.setItem(`MaxWaitingTimeByHour_groupName_${props.identifier}_user${props.id}`, groupName);
        MonitorWSService.stompClient.send("/app/subscribe/maximumwaitingtimebyhour", {}, JSON.stringify({
            token: props.token,
            groupId: groupId
        }));
    }
    return (
        <div className={"card card-flush overflow-hidden h-lg-20 widget-container"} id="maxwaitingtimebyhourwidget">
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("hourglass-start")} /> {t("maxwaitingtimebyhour")} - {groupName}</span>

                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools key={`tools_${props.identifier}`} closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem", height: "100%" }}>
                <Row>
                    <Col>
                        <div className="fs-3hx fw-bold text-gray-800 text-center">{seconds2HMS(maxTimeWaiting)}</div>
                    </Col>
                </Row>
                <Chart
                    palette="Violet"
                    dataSource={calls}
                    height={"300px"}
                    rtlEnabled={props.rtl}
                >
                    <CommonSeriesSettings
                        argumentField="hour"
                        type="spline"
                    />
                    <CommonAxisSettings>
                        <Grid visible={true} />
                    </CommonAxisSettings>
                    {
                        architectureSources.map((item) => <Series
                            key={item.value}
                            valueField={item.value}
                            name={item.name}
                            color={item.color}
                        />)
                    }
                    <Margin bottom={20} />
                    <ArgumentAxis
                        allowDecimals={false}
                        axisDivisionFactor={60}
                    >
                        <Label
                            wordWrap="none"
                            overlappingBehavior={"rotate"}
                            rotationAngle={35}
                        >
                            <Format type="decimal" />
                        </Label>
                    </ArgumentAxis>
                    <Export enabled={false} />
                    <Tooltip enabled={true} />
                    <Animation
                        enabled={false}
                    />
                    <Legend
                        visible={false}
                    />
                </Chart>

            </div>
            <WidgetSettings key={`settings_${props.identifier}`} showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroup={setGroup} groupId={groupId} groupName={groupName} selectionType={selectionTypes.GROUP}></WidgetSettings>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id
    };
};

export default connect(mapStateToProps, { removeWidget })(MaxWaitingTimeByHour);